export default __webpack_public_path__ + "static/media/blog-driveway-pattern-003.736d7559.jpg";